export default __webpack_public_path__ + "static/media/3045.760acab5.jpg";